import { DATA_CATALOG_API_PREFIX } from '@components/dataCatalog/constants';
import { AdvancedKeyword } from './createTrackingPlans/types';

export const TRACKING_PLAN_DOCS =
  'https://www.rudderstack.com/docs/data-governance/tracking-plans/';

export enum TRACKING_PLAN_TABS {
  Overview = 'Overview',
  Schema = 'Schema',
  Sources = 'Sources',
  Settings = 'Settings',
  Activity = 'Activity',
  Codegen = 'Codegen',
}

const SKIP_REBUILD_SCHEMAS = '?rebuildSchemas=false';

export const API_URLS = {
  templates: `${DATA_CATALOG_API_PREFIX}/templates`,
  templateRules: (templateId: string) => `${API_URLS.templates}/${templateId}`,
  trackingPlans: `${DATA_CATALOG_API_PREFIX}/tracking-plans`,
  singleTrackingPlan: (id: string, options?: { skipRebuildSchemas?: boolean }) =>
    `${API_URLS.trackingPlans}/${id}${options?.skipRebuildSchemas ? SKIP_REBUILD_SCHEMAS : ''}`,
  oldSingleTrackingPlan: (id: string) => `/trackingPlans/${id}`,
  trackingPlanEvents: (trackingPlanId: string, options?: { skipRebuildSchemas?: boolean }) =>
    `${API_URLS.singleTrackingPlan(trackingPlanId)}/events${
      options?.skipRebuildSchemas ? SKIP_REBUILD_SCHEMAS : ''
    }`,
  singleTrackingPlanEvent: (
    trackingPlanId: string,
    eventId: string,
    options?: { skipRebuildSchemas?: boolean },
  ) =>
    `${API_URLS.trackingPlanEvents(trackingPlanId)}/${eventId}${
      options?.skipRebuildSchemas ? SKIP_REBUILD_SCHEMAS : ''
    }`,
  activityLogs: (id: string) => `${DATA_CATALOG_API_PREFIX}/tracking-plan-activity-logs/${id}`,
  migrateTrackingPlan: (id: string) => `${API_URLS.singleTrackingPlan(id)}/migrate`,
  copyTrackingPlan: (id: string) => `${API_URLS.singleTrackingPlan(id)}/copy`,
  trackingPlansByWorkspace: (workspaceId: string) => `/workspaces/${workspaceId}/trackingPlans`,
};

export const MESSAGES = {
  cancel:
    'You’re about to leave this page with unsaved changes. Are you sure you want to continue?',
};

export const NESTED_PROPERTIES_DEPTH = 3;

export const OLD_TRACKING_PLAN_CREATION_TYPE = 'Google sheet/Tracking Plan API';

export const supportedAdvancedKeywords: AdvancedKeyword[] = [
  'enum',
  'format',
  'minimum',
  'maximum',
  'minLength',
  'maxLength',
  'multipleOf',
  'exclusiveMaximum',
  'exclusiveMinimum',
  'pattern',
  'uniqueItems',
  'minItems',
  'maxItems',
  'additionalProperties',
];

export const TRACKING_PLAN_PATH = {
  TRACKING_PLANS: '/trackingPlans',
  TRACKING_PLAN_DETAILS: (id: string) => `${TRACKING_PLAN_PATH.TRACKING_PLANS}/${id}`,
  TRACKING_PLAN_EVENT_DETAILS: (id: string, eventId: string) =>
    `${TRACKING_PLAN_PATH.TRACKING_PLAN_DETAILS(id)}/events/${eventId}`,
};
